<div class="grids-container light-select"
     [style.grid-template-columns]="gridColumn()"
     [style.grid-gap.px]="gapSize()"
     [style.grid-row-gap.px]="rowGapSize ?? gapSize()"
     [style.width]="gridSize()"
     [style.max-width]="gridSize()">
  <div class="img-container" *ngFor="let item of items; let index = index; trackBy: trackByFn"
       [class.desktop]="!windowService.isMobileDevice() && desktopPadding"
       [ngStyle]="itemStyles?.[index]">
    <button *ngIf="customClick; else linkContent" appFocusRemove (click)="itemClick.emit([item, index])">
      <ng-container [ngTemplateOutlet]="img"/>
    </button>
    <ng-template #linkContent>
      <app-universal-link *ngIf="undefined | linkToUrl: item.link: openNewWindow as url"
                          [url]="url[0]"
                          [meta]="item.meta"
                          [openNewWindow]="url[1]"
                          [content]="img"
                          (linkClicked)="openProduct(undefined, item.link, item.meta?.productId, item.colorId)"/>
    </ng-template>
    <ng-template #img>
      <app-image-loading
        [src]="item.hash"
        [alt]="item.meta?.name ?? ''"
        [clickable]="true"
        [targetWidth]="imgWidth()"
        [targetHeight]="imgHeight()"
        [borderRadius]="borderRadius"
        [ssrSuffix]="item.isClothHash ? '' : '@2x'"
        [widthCss]="imgWidthCss()"/>
    </ng-template>
    <ng-container *ngIf="(windowService.isMobileDevice() ? mobileColorBlockSize : colorBlockSize) as colorSize">
      <div class="item-container" *ngIf="showColor && item.colors.length"
           [class.mobile]="windowService.isMobileDevice()"
           [style.margin-top.px]="blockMarginTop()"
           [style.grid-template-columns]="'repeat(auto-fit, ' + colorSize +'px)'">
        <ng-container *ngFor="let color of item.colors; trackBy: trackByColor">
          <a class="color-tag" appFocusRemove
             [routerLink]="item.meta?.productId | colorLink: color.id"
             (click)="openProduct($event, item.link, item.meta?.productId, color.id)">
            <div class="color-block" *ngIf="color.hex; else img"
                 [style.background-color]="'#' + color.hex"
                 [style.border-color]="color | colorWithBorder"
                 [style.width.px]="colorSize"
                 [style.height.px]="colorSize"></div>
            <ng-template #img>
              <app-image-loading [src]="color.thumbnail ?? ''"
                                 [alt]="color.name"
                                 [clickable]="true"
                                 [originalQuality]="false"
                                 [ssrSuffix]="windowService.isMobileDevice() ? '@2x' : '@1x'"
                                 [targetWidth]="colorSize"
                                 [targetHeight]="colorSize"/>
            </ng-template>
          </a>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="(windowService.isMobileDevice() ? mobileSizeBlockSize : sizeBlockSize) as sizeBlock">
      <div class="item-container size-margin" *ngIf="showSize && item.sizes.length"
           [class.mobile]="windowService.isMobileDevice()"
           [style.grid-template-columns]="'repeat(auto-fit,' + 'minmax(' + sizeBlock + 'px' + ',max-content))'">
        <a class="size-tag" appFocusRemove
           *ngFor="let size of item.sizes; trackBy: trackBySize"
           [class.disable]="size.stockRemind && !size.num"
           [style.line-height.px]="sizeBlock"
           [style.height.px]="sizeBlock"
           [routerLink]="size.skuId | sizeLink"
           (click)="openProduct($event, item.link, undefined, undefined, size.skuId)">
          <span>{{size.name}}</span>
        </a>
      </div>
    </ng-container>
    <ng-template [ngTemplateOutlet]="metaRef"
                 [ngTemplateOutletContext]="{item: item}"/>
  </div>
</div>
